export function Timeline2024({isOpen, data}){

    return ( 

    <div
        style={{
          display: "flex",

          listStyle: 'none',
          overflow: 'hidden',
          maxHeight: isOpen ? '10000px' : '0',
          transition: 'max-height 0.5s ease',
          width: "100%",
          justifyContent: "center"
          }}
      >
        
    <div className="table-container">
    <table>
    <tbody>
    <tr>
<td className="year normal-glow-text">Dec 2024</td>
        <td className="table-card">
        <a href="https://eliya-g.github.io/barbell-workout-planner/">
        <h3>Front-End Developer</h3>
        <div className="mobile-container">
        <h3 className="para-spacer">Workout Planner Project</h3>
        <span className="mobile-year-para normal-glow-text">Dec 2024</span>
        </div>
        </a>
        <ul>
            <li className="normal-glow-text">Helped 120+ users plan their workouts.</li>
            <li className="normal-glow-text">Created a light weight workout parsing website.</li>
            <li className="normal-glow-text">Sleek yet minimal design.</li>
        </ul>
        <div className="bottom-icons">
        <div className="icon-tool-tip" data-tooltip="Javascript" >
        <img className="svg-glow" src="/tech_icons/javascript.svg" alt="Javascript" height="32px" width="32px" />
        </div>
        <div className="icon-tool-tip" data-tooltip="HTML" >
        <img className="svg-glow" src="/tech_icons/html.svg" alt="HTML" height="35px" width="35px" />
        </div>
        <div className="icon-tool-tip" data-tooltip="CSS" >
        <img className="svg-glow" src="/tech_icons/css.svg" alt="CSS" height="32px" width="32px" />
        </div>
        </div>
        </td>
        </tr>
                <tr>
<td className="year normal-glow-text">Oct 2024</td>
        <td className="table-card">
        <a href="https://github.com/Eliya-G/meeting-site">
        <h3>Front-End Developer</h3>
        <div className="mobile-container">
        <h3 className="para-spacer">Meeting Room Booking Project</h3>
        <span className="mobile-year-para normal-glow-text">Oct 2024</span>
        </div>
        </a>
        <ul>
            <li className="normal-glow-text">Built a full-stack meeting scheduler with Python/Django and SQLite, featuring room booking and database CRUD operations.</li>
        </ul>
        <div className="bottom-icons">
        <div className="icon-tool-tip" data-tooltip="Django" >
        <img className="svg-glow" src="/tech_icons/django.svg" alt="Django" height="25px" width="25px"/>
        </div>
        <div className="icon-tool-tip" data-tooltip="Sqlite" >
        <img className="svg-glow-little" src="/tech_icons/sqlite.svg" alt="Sqlite" height="30px" width="30px"/>
        </div>
        <div className="icon-tool-tip" data-tooltip="Jinja" >
        <img className="svg-glow-little" src="/tech_icons/jinja.svg" alt="Jinja" height="30px" width="30px"/>
        </div>
  
        </div>
        </td>
        </tr>

           <tr>
<td className="year normal-glow-text">Sep 2024</td>
        <td className="table-card">
        <a href="https://github.com/Eliya-G/coffee-o-clock">
        <h3>Full-Stack Developer</h3>
        <div className="mobile-container">
        <h3 className="para-spacer">Coffee O' Clock Project</h3>
        <span className="mobile-year-para normal-glow-text">Sep 2024</span>
        </div>
        </a>
        <a href="https://github.com/Eliya-G/coffee-o-clock/stargazers" className="normal-glow-text star-offset"><p className="normal-glow-text"><img src="./images/star.png" alt="Github star" className='star' /> {data} stars on Github</p></a>
        <ul>
            <li className="normal-glow-text">Provided real world data helping 1000+ users understand how much coffee they drink.</li>
            <li className="normal-glow-text">A developer tested tool with 200+ stars on Github.</li>
            <li className="normal-glow-text">Provided the foundation for further DNA metabolism inquiry.</li>
        </ul>
        <div className="bottom-icons">
        <div className="icon-tool-tip" data-tooltip="Tkinter" >
        <img className="svg-glow" src="/tech_icons/tkinter.svg" alt="Tkinter" height="35px" width="35px"/>
        </div>
        <div className="icon-tool-tip" data-tooltip="Python" >
        <img className="svg-glow" src="/tech_icons/python.svg" alt="Python" height="30px" width="30px"/>
        </div>
        </div>
        </td>
        </tr>
            <tr>
<td className="year normal-glow-text">Jul 2024</td>
        <td className="table-card non-icon-spacer">
                            <h3>Python Developer Bootcamp</h3>
        <div className="mobile-container">
        <h3 className="para-spacer">Education/Online Course</h3>
        <span className="mobile-year-para normal-glow-text">Jul 2024</span>
        </div>
        <ul>
            <li className="normal-glow-text">Integrated databases for websites using MySQL, PostgreSQL, SQLAlchemy.</li>
            <li className="normal-glow-text">Familiar with displaying data using Python’s Matplotlib and Pandas graphing library.</li>
            <li className="normal-glow-text">Learned web frameworks such as Flask and Django.</li>
        </ul>
        </td>
        </tr>

    </ tbody>
    </table>
    </div>
    </div>
    ) 
}
